<template>
  <div>
    <div class="text-primary text-subtitle2 text-uppercase q-mb-sm">
      How Do Import Requests Work?
    </div>
    <p>
      A request is created when an action is required by the
      client to allow Private Footprint to update their posts.
    </p>
    <div v-if="['Facebook', 'Instagram'].includes(platform)">
      <p>
        The client receives an email with instructions to
        request their updated data file from {{ platform }},
        which when ready, the client will upload into
        Private Footprint. It may take anywhere between
        1 to 72 hours for {{ platform }} to prepare the data file.
        The client will be notified by email when the file is ready.
        The actual process to request their data file does not take more than a few minutes.
      </p>
      <p>
        Since {{ platform }} content is accessed by requesting the client's data file,
        importing {{ platform }} posts requires manually sending a request to the
        client each time you want their latest posts.
      </p>
    </div>
    <div v-else>
      <p>
        For {{ platform }}, Private Footprint retains read-only access to the client's posts,
        allowing new posts to be imported automatically on a daily basis.
      </p>
      <p>
        If access is lost, a request is sent to the client to restore the access so
        daily post importing can resume.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReconnectRequest } from '@/social/types';

export default defineComponent({
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  computed: {

  },
});
</script>
